import { z } from 'zod';
const getPastShiftParticipantsByShiftIdParamsSchema = z.object({
    shiftId: z.string().uuid(),
    limit: z.number().optional(),
    offset: z.number().optional(),
});
const getPastShiftParticipantsByShiftIdDataSchema = z.object({
    id: z.string().uuid(),
    created: z.number(),
    createdBy: z.string().trim().min(1),
    updated: z.number(),
    updatedBy: z.string().trim().min(1),
    parentId: z.string().uuid().optional(),
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
    columns: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
});
const getPastShiftParticipantsByShiftIdResponseSchema = z.object({
    data: getPastShiftParticipantsByShiftIdDataSchema.array(),
    total: z.number(),
});
const partialGetPastShiftParticipantsByShiftIdDataSchema = getPastShiftParticipantsByShiftIdDataSchema.omit({
    columns: true,
    permissions: true,
});
const partialGetPastShiftParticipantsByShiftIdResponseSchema = getPastShiftParticipantsByShiftIdResponseSchema.omit({
    data: true,
});
export const getPastShiftParticipantsByShiftIdFunctionDef = {
    name: 'getPastShiftParticipantsByShiftId',
    requestSchema: getPastShiftParticipantsByShiftIdParamsSchema,
    responseSchema: getPastShiftParticipantsByShiftIdResponseSchema,
};
